// extracted by mini-css-extract-plugin
export default {"bubble":"styles_bubble__rnImu","moreButton":"styles_moreButton__OOwDd","moreButtonActive":"styles_moreButtonActive__BFIkV"};